import { render, staticRenderFns } from "./FolderSettingsIcon.vue?vue&type=template&id=1e9fd954"
import script from "./FolderSettingsIcon.vue?vue&type=script&lang=js"
export * from "./FolderSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports